import { hotjarInit } from './lib/utils/hotjar';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';
import { getEnvironment } from '$lib/utils/environment';
import { getSentryConfig } from '$lib/services/sentry/config';
import { AppInitializationService } from '$lib/services/app-initialization';

Sentry.init({
	...getSentryConfig({
		environment: getEnvironment(),
		// @ts-ignore
		release: __RELEASE_NAME__ || 'local',
		tracesSampleRate: 0.25
	}),
	integrations: [
		Sentry.thirdPartyErrorFilterIntegration({
			filterKeys: ['testing-key'],
			behaviour: 'apply-tag-if-contains-third-party-frames'
		})
	],
	allowUrls: [/https?:\/\/(?:www\.|web\.dev\.)?abcmouse\.com/]
});

export const handleError = handleErrorWithSentry();

hotjarInit();

/**
 * Hook for client init
 */
export async function init() {
	await AppInitializationService.initialize();
}
